// extracted by mini-css-extract-plugin
module.exports = {"jobCard-tag":"jobCard-tag"};